export const EN = { code: 'en', language: 'English' }

export const ZH_CN = { code: 'zh-CN', language: '简体中文' }

export const Language = {
  [EN.code]: EN,
  [ZH_CN.code]: ZH_CN,
}
